import { useFlags } from "launchdarkly-react-client-sdk";
import React, { useState } from "react";

import { NoteInput } from "./LegacyNoteInput";
import { ObjectiveFormSection } from "./LegacyObjectiveFormSection";
import { ObjectiveToggles } from "./LegacyObjectiveToggles";
import { useFindAndReplace } from "../../../hooks";

export default function SOAPForm({ control, note }) {
  const [isEditFieldModeActive, setIsEditFieldModeActive] =
    useState(false);
  const { selectFindAndReplaceText } = useFindAndReplace();
  const {
    aiAssistantEnabled,
    languageAiAssistantEnabled,
    subheadingsAiAssistantEnabled,
  } = useFlags();
  return (
    <div className="space-y-2">
      <NoteInput
        control={control}
        title={"Subjective"}
        fieldName="subjective"
        headerStyle="bg-blue-400 dark:bg-blue-600"
        boxStyle="border-blue-300 bg-blue-50 dark:bg-blue-700/20 dark:border-blue-600 divide-blue-300 dark:divide-blue-600"
        onMouseUp={(e) => {
          selectFindAndReplaceText(e);
        }}
        noteUuid={note?.uuid}
        aiAssistantEnabled={aiAssistantEnabled}
        languageAiAssistantEnabled={languageAiAssistantEnabled}
        subheadingsAiAssistantEnabled={subheadingsAiAssistantEnabled}
      />

      <div className="relative">
        <ObjectiveToggles
          note={note}
          isEditFieldModeActive={isEditFieldModeActive}
          setIsEditFieldModeActive={setIsEditFieldModeActive}
        />
        <ObjectiveFormSection
          isEditFieldModeActive={isEditFieldModeActive}
          onMouseUp={(e) => {
            selectFindAndReplaceText(e);
          }}
          noteUuid={note?.uuid}
          aiAssistantEnabled={aiAssistantEnabled}
          languageAiAssistantEnabled={languageAiAssistantEnabled}
          subheadingsAiAssistantEnabled={
            subheadingsAiAssistantEnabled
          }
        />
      </div>

      <NoteInput
        control={control}
        title={"Assessment"}
        fieldName="assessment"
        headerStyle="bg-green-400 dark:bg-green-600"
        boxStyle="border-green-300 bg-green-50 dark:bg-green-700/20 dark:border-green-600 divide-green-300 dark:divide-green-600"
        onMouseUp={(e) => {
          selectFindAndReplaceText(e);
        }}
        noteUuid={note?.uuid}
        aiAssistantEnabled={aiAssistantEnabled}
        languageAiAssistantEnabled={languageAiAssistantEnabled}
        subheadingsAiAssistantEnabled={subheadingsAiAssistantEnabled}
      />

      <NoteInput
        control={control}
        title={"Plan"}
        fieldName="plan"
        headerStyle="bg-yellow-400 dark:bg-yellow-600"
        boxStyle="border-yellow-300 bg-yellow-50 dark:bg-yellow-700/20 dark:border-yellow-600 divide-yellow-300 dark:divide-yellow-600"
        onMouseUp={(e) => {
          selectFindAndReplaceText(e);
        }}
        noteUuid={note?.uuid}
        aiAssistantEnabled={aiAssistantEnabled}
        languageAiAssistantEnabled={languageAiAssistantEnabled}
        subheadingsAiAssistantEnabled={subheadingsAiAssistantEnabled}
      />

      <div className="pt-4">
        <NoteInput
          control={control}
          title={"Additional Notes"}
          fieldName="additionalNotes"
          headerStyle="bg-gray-400 dark:bg-gray-600"
          boxStyle="border-gray-300 bg-gray-50 dark:bg-gray-700 dark:border-gray-600 divide-gray-300 dark:divide-gray-600"
          onMouseUp={(e) => {
            selectFindAndReplaceText(e);
          }}
          noteUuid={note?.uuid}
          aiAssistantEnabled={aiAssistantEnabled}
          languageAiAssistantEnabled={languageAiAssistantEnabled}
          subheadingsAiAssistantEnabled={
            subheadingsAiAssistantEnabled
          }
        />
      </div>
    </div>
  );
}
